import { render, staticRenderFns } from "./BlockUsageWarningModal.vue?vue&type=template&id=455b261e&"
import script from "./BlockUsageWarningModal.vue?vue&type=script&lang=js&"
export * from "./BlockUsageWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports